import { Link as RouterLink } from 'react-router-dom';

// material-ui
import Link from '@mui/material/Link';

// project imports
import useAuth from 'hooks/useAuth';
import { DASHBOARD_PATH, ADMIN_PATH } from 'config';
import Logo from 'ui-component/Logo';

// ==============================|| MAIN LOGO ||============================== //

export default function LogoSection() {
  const { user } = useAuth();
  const homePath = user?.admin ? ADMIN_PATH : DASHBOARD_PATH;
  return (
    <Link component={RouterLink} to={homePath} aria-label="theme-logo" sx={{ textDecoration: 'none' }}>
      <Logo />
    </Link>
  );
}
